export default "__VITE_ASSET__4140af7f__"